<template>
  <div class="action-config-item">
    <div class="mb-4">
      <label for="action-name" class="block text-sm font-semibold text-gray-700">Action Name</label>
      <el-input
        v-model="localStep.label"
        id="action-name"
        placeholder="Enter Action Name"
        clearable
        class="w-full rounded-md"
      />
    </div>
    <el-select
      v-model="localStep.approval_formbuilder_id"
      placeholder="Select form builder"
      clearable
      filterable
    >
      <el-option
        v-for="(field, i) in getApprovalFormBuilders()"
        :key="field + i"
        :value="field._id"
        :label="field.name"
      ></el-option>
    </el-select>
    <!-- Footer Actions -->
    <div class="automation-footer-actions mt-4 flex justify-end gap-2">
      <el-button @click="cancelChanges">Cancel</el-button>
      <el-button type="primary" @click="saveChanges">Save</el-button>
    </div>
  </div>
</template>

<script>
  import StepEditableMixin from './StepEditableMixin';
  export default {
    name: 'SendApprovalAction',
    props: {
      step: Object,
      currentEntity: Object,
      allFormbuilders: Array,
    },
    mixins: [StepEditableMixin],
    methods: {
      getApprovalFormBuilders() {
        return this.allFormbuilders.filter(
          (f) => f.steps[0].entity == this.currentEntity._id && f.is_approval_form
        );
      },
    },
  };
</script>
<style scoped>
  .action-config-item {
    background-color: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 0.75rem 1rem;
    font-family:
      'Inter',
      system-ui,
      -apple-system,
      BlinkMacSystemFont,
      'Segoe UI',
      Roboto,
      'Helvetica Neue',
      Arial,
      sans-serif;
    color: #374151;
  }

  .action-config-item .el-select {
    width: 100%;
    border-radius: 6px;
  }

  .el-select .el-input__inner {
    padding: 0.4rem 0.75rem;
  }

  .el-select .el-select-dropdown__item:hover {
    background-color: #eff6ff;
  }
</style>
